<template>
    <div>
        <a-modal :title="title" :visible='sureVisible' :width="1470" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button type="primary" @click="toWarehouse">转入库单</a-button>
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
              <span class="lisenceTitle" >基础信息</span>
              <a-descriptions >
                <a-descriptions-item label="核验单号">{{baseInfo.verificationBillNo}}</a-descriptions-item>
                <a-descriptions-item label="出库单号">{{baseInfo.outBillNo}}</a-descriptions-item>
                <a-descriptions-item label="随货同行单">{{baseInfo.withOrderBillNo}}</a-descriptions-item>
<!--                <a-descriptions-item label="包装数量">{{baseInfo.totalNum}}</a-descriptions-item>-->
                <a-descriptions-item label="包装数量详情">{{baseInfo.specNumDetail}}</a-descriptions-item>
                <a-descriptions-item label="出库方">{{baseInfo.outPartyName}}</a-descriptions-item>
<!--                <a-descriptions-item label="接收方">{{baseInfo.receiverName}}</a-descriptions-item>-->
                <a-descriptions-item label="核验人">{{baseInfo.validatorName}}</a-descriptions-item>
                <a-descriptions-item label="核验时间">{{baseInfo.validateEndTime}}</a-descriptions-item>
                <a-descriptions-item v-if="baseInfo.platformType == 0" label="来源">小程序</a-descriptions-item>
                <a-descriptions-item v-if="baseInfo.platformType == 1" label="来源">APP</a-descriptions-item>
                <a-descriptions-item v-if="baseInfo.platformType == 2" label="来源">客户端</a-descriptions-item>
              </a-descriptions>
            </div>
            <div>
                <span class="lisenceTitle" >核验产品信息</span>
                <a-table ref="table" size="middle" bordered
                    :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
                    :loading="loading" :pagination="ipagination2" @change="getProduct"
                    style="word-break: break-all;">

                    <span slot="action" slot-scope="text, record">
                        <a type="primary" @click="handleDelete(record)">删除</a>
                    </span>
                    <template slot="createTime" slot-scope="createTime">
                        <span>{{changetime(createTime)}}</span>
                    </template>
                </a-table>
            </div>
            <div>
                <span class="lisenceTitle" >核验码</span>
                <!-- 查询区域 -->
                <div class="table-page-search-wrapper">
                <!-- 搜索区域 -->
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                    <a-row :gutter="24">
                    <a-col :md="8" :lg="6"  :sm="24">
                        <a-form-item label="核验码" >
                        <a-input placeholder="请输入核验码" v-model="queryParam.validCode"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="8" :lg="6"  :sm="24">
                        <a-form-item label="批次">
                        <a-input placeholder="请输入批次" v-model="queryParam.productBatch"></a-input>
                        </a-form-item>
                    </a-col>
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-col :md="12" :sm="24">
                        <a-button type="primary" @click="searchQueryForList">查询</a-button>
                        <a-button style="margin-left: 8px" @click="searchResetForList()">重置</a-button>
                        </a-col>
                    </span>
                    </a-row>
                </a-form>
                </div>
                <a-table ref="table" size="middle" bordered
                    :columns="columnsCode" :dataSource="dataSourceCode" :components="handleDrag(columns)" :pagination="ipagination" :loading="loading"
                    :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: getProduct, columnWidth: '40px' }"
                    @change="handleTableChange">
                    <span slot="action" slot-scope="text, record">
                        <a type="primary" @click="handleDelete(record)">删除</a>
                    </span>
                    <template slot="createTime" slot-scope="createTime">
                        <span>{{changetime(createTime)}}</span>
                    </template>
                    <template slot="status" slot-scope="status">
                        <a-tag v-if="status === 0" color="red">未核验</a-tag>
                        <a-tag v-else-if="status === 1" color="green">已通过</a-tag>
                        <a-tag v-else-if="status === 2" color="red">未通过</a-tag>
                        <a-tag v-else-if="status === 3" color="green">上级已通过</a-tag>
                        <a-tag v-else-if="status === 4" color="red">上级未通过</a-tag>
                    </template>
                </a-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { getInspectionProduct, getInspectionProductCode,getInfo,convertStorage,queryCodeById } from '@/api/api'
import { campListMixins } from '../mixins/campListMixins'
export default {
    name: 'campDetail',
    mixins: [campListMixins],
    data() {
      return {
        baseInfo:{},
        title: '详情',
        sureVisible:false,
        ipagination: {
            pageSize: 10, // 每页显示的条数
            showSizeChanger: true, // 是否可以改变每页显示的条数
            pageSizeOptions: ['10', '20', '30', '40'], // 可选的每页显示条数
            showQuickJumper: true, // 是否可以快速跳转到指定页
            showTotal: total => `共 ${total} 条`, // 显示总条数和当前数据范围
            current: 1, // 当前页数
            total: 50, // 总条数
        },
        ipagination2: {
          pageSize: 5, // 每页显示的条数
          showSizeChanger: true, // 是否可以改变每页显示的条数
          pageSizeOptions: ['5','10', '20', '30', '40'], // 可选的每页显示条数
          showQuickJumper: true, // 是否可以快速跳转到指定页
          showTotal: total => `共 ${total} 条`, // 显示总条数和当前数据范围
          current: 1, // 当前页数
          total: 50, // 总条数
        },
        searchData: '',
        searchId:'',
        // 查询条件
        queryParam: {
            validCode: '',
            productBatch: ''
        },
        labelCol: {
            span: 4,
        },
        wrapperCol: {
            span: 20,

        },
        dataSourceCode: [],
        e:{},
        columns: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        //   { title: '核验单表id', dataIndex: 'hyBillRecordId',width: 80, align: "center",scopedSlots: { customRender: 'licenseType' } },
          { title: '产品名称', dataIndex: 'productName', width: 160, ellipsis: true, render: (text) => text || "--" },
          { title: '批次', dataIndex: 'productBatch',width: 80, render: (text) => text || "--"},
        //   { title: '产品码', dataIndex: 'productCode', width: 220, render: (text) => text || "--" },
        //   { title: '产品数量', dataIndex: 'totalNum', width: 60 ,ellipsis: true, render: (text) => text || "--" },
          // { title: '包装数量详情', dataIndex: 'specNumDetail', width: 200 , render: (text) => text || "--" },
        ],
        columnsCode: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
          { title: '核验码', dataIndex: 'validCode',width: 240, align: "center"} ,
          { title: '核验状态', dataIndex: 'status', width: 60, ellipsis: true, render: (text) => text || "--",scopedSlots: { customRender: 'status' } },
          { title: '批次', dataIndex: 'productBatch',width: 120, render: (text) => text || "--"},
          { title: '包装级别', dataIndex: 'level', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        ],
      }
    },
    mounted(){

    },
    methods: {
      //入库
      toWarehouse: async function() {

        const snlist = await  queryCodeById({ recordId:this.e.id })

        // queryCodeById({
        //   recordId:this.e.id
        // }).then(res=>{
        //   console.log(res.result)
        // })

        const params = {
          info: {
            organId : '',
            operTime : '',
            number : '',
            defaultNumber : '',
            discount : 0,
            discountMoney : 0,
            discountLastMoney : 0,
            otherMoney : 0,
            changeAmount : 0,
            debt : 0,
            type : '入库',
            subType : '采购',
            totalPrice : 0,
            accountIdList : '',
            accountMoneyList : '',
            fileName : '',
            status : ''
          },
          rows:[]
        }
        //供应商id
        params.info.organId = this.baseInfo.outPartyId
        //检验单号
        params.info.number = this.baseInfo.verificationBillNo
        //检验单号
        params.info.defaultNumber = this.baseInfo.withOrderBillNo

        this.dataSource.forEach(d=>{
          params.rows.push({
            id:'',
            name:d.productName,
            standard:d.standard,
            model:d.model,
            color:null,
            materialOther:'',
            stock:'',
            unit:d.unit,
            snList:snlist.result,
            batchNumber:d.productBatch,
            expirationDate:'',
            sku:'',
            preNumber:'',
            finishNumber:'',
            operNumber:d.totalNum,
            unitPrice:null,
            allPrice:0,
            taxRate:0,
            taxMoney:0,
            taxLastMoney:0,
            remark:d.specNumDetail,
            linkId:'',
            orderNum:'',
            depotId:'',
            barCode:d.barCode
          })
        })
        console.log('this.dataSource->this.dataSourceCode->this.baseInfo->params->', this.dataSource,this.dataSourceCode,this.baseInfo,params)

        params.info = JSON.stringify(params.info)
        params.rows = JSON.stringify(params.rows)


        convertStorage(params).then(res=>{
          if (res.code == 200 ) {
            this.$message.success('成功')
            this.handleCancel()
          } else {
            this.$message.error(res.message)
          }
        })
      },
        initShow(e){
          this.e = e
            console.log(e,'======================e===============')
            this.searchData = e
            this.searchId=e.id
            this.sureVisible = true
            this.getProduct()
            this.getProductCode(e)
            this.getInfo(e)
        },
        async getInfo(e){
          const res = await getInfo({id:e.id})
          if (res.code == 200 && res.success == true) {
            console.log(res)
            this.baseInfo = res.result
          } else {
            this.$message.error(res.message)
          }
        },
        async getProduct(page){
          if(page){
            this.ipagination2.current = page.current
            this.ipagination2.pageSize = page.pageSize
          }
          let params = {
            recordId : this.e.id,
            pageNo: this.ipagination2.current,
            pageSize: this.ipagination2.pageSize
          }
          const res = await getInspectionProduct(params)
          if (res.code == 200 && res.success == true) {
            this.dataSource = res.result.records
            this.ipagination2.total = res.result.total
          } else {
            this.$message.error(res.message)
          }
        },
        async getProductCode(e){
            // this.searchId = e.id
            let params = {
                hyBillRecordId : e.id,
                search: {
                    validCode: this.queryParam.validCode,
                    productBatch: this.queryParam.productBatch,
                },
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            const res = await getInspectionProductCode(params)
            if (res.code == 200 && res.success == true) {
                console.log(res)
                this.$message.success(res.message)
                this.dataSourceCode = res.result.records
                this.ipagination.total = res.result.total
            } else {
                this.$message.error(res.message)
            }
        },
        searchQueryForList(){
            var searchDatas = this.searchData
            this.getProductCode(searchDatas)
        },
        async searchResetForList(){
            var searchDatas = this.searchData
            let params = {
                hyBillRecordId : searchDatas.id,
                search: {
                    validCode: '',
                    productBatch: '',
                },
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            const res = await getInspectionProductCode(params)
            if (res.code == 200 && res.success == true) {
                console.log(res)
                this.$message.success(res.message)
                this.dataSourceCode = res.result.records
                this.ipagination.total = res.result.total
                this.queryParam.validCode = ''
                this.queryParam.productBatch = ''
            } else {
                this.$message.error(res.message)
            }
        },
        async handleTableChange(page,pageSize){
            this.ipagination.current = page.current
            this.ipagination.pageSize = page.pageSize
            let params = {
                hyBillRecordId : this.searchId,
                search: {
                    validCode: this.queryParam.validCode,
                    productBatch: this.queryParam.productBatch,
                },
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            const res = await getInspectionProductCode(params)
            if (res.code == 200 && res.success == true) {
                console.log(res)
                this.$message.success(res.message)
                this.dataSourceCode = res.result.records
                this.ipagination.total = res.result.total
            } else {
                this.$message.error(res.message)
            }
        },
        handleOk(){
          this.$emit('ok')
            this.sureVisible = false
        },
        handleCancel(){
          this.$emit('ok')
            this.sureVisible = false
        },
        modalFormOk(){
            this.loadData()
        },
        modalFormClose(){
            this.loadData()
        }
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
